/*
 * Copyright (c) 2026 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, July 6th 2026, 1:12:32 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Accordion, AccordionProps, AccordionSummary, AccordionDetails } from "@mui/material";
import { OSIconButton } from "ui-widgets";

type OSAccordionProps = {
  children: React.ReactNode;
  heading: React.ReactNode;
  mainSx?: AccordionProps["sx"];
};

export const OSAccordion = ({ children, heading, mainSx }: OSAccordionProps) => {
  return (
    <Accordion sx={mainSx}>
      <AccordionSummary
        expandIcon={<OSIconButton color="primary" icon={<KeyboardArrowDownIcon />} />}
        aria-controls="accordion"
        id="accordion-header"
      >
        {heading}
      </AccordionSummary>
      <AccordionDetails sx={{ padding: 2 }}>{children}</AccordionDetails>
    </Accordion>
  );
};
